<template>
  <div class="page">
    <img
      v-if="!environment"
      class="goback"
      @click="goBack"
      src="@/assets/images/gold-coin/go_back.png"
      alt=""
    />
    <div class="content">
      <img src="@/assets/images/gold-coin/logo.png" alt="" />
      <h3>惠职工 享福利</h3>
      <van-field
        v-model="realName"
        left-icon="manager-o"
        placeholder="请输入个人姓名"
      />
      <van-button @click="submit">绑定</van-button>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { bind } from '@/api/gold-coin'
export default {
  data() {
    return {
      realName: '',
      code: '',
      environment: false,
    }
  },
  created() {
    this.code = this.$getUrlKey('code')
    const token = this.$getUrlKey('access_token')
    console.log('token', token)
    console.log('code', this.code)
    if (token) {
      Cookies.set('token', token, {
        expires: 30,
      })
    } else if (!Cookies.get('token')) {
      // 跳登录页
      const callbackUrl = `${FRONTEND_HOST}/gold-coin/bind-name`
      this.$router.push({
        path: `/login?callbackUrl=${callbackUrl}`,
      })
    }
    console.log('token1', token)
    console.log('code1', this.code)
    this.getIsWxMiniProgram()
  },
  methods: {
    async getIsWxMiniProgram() {
      const WxMiniProgram = await this.$getIsWxMiniProgram()
      console.log('WxMiniProgram', WxMiniProgram)
      if (WxMiniProgram) {
        this.environment = true
      } else {
        this.environment = false
      }
    },
    submit() {
      if (!this.realName) {
        this.$toast('请填写绑定名称')
        return
      }
      bind({
        realName: this.realName,
        code: this.code,
      }).then(({ data }) => {
        if (data.code === 200) {
          console.log('绑定成功')
          this.$toast('绑定成功')
          if (this.environment) {
            // this.$wx.miniProgram.redirectTo({
            //   url: `/profile/gold-coin/BindAccount`,
            // })
            this.$wx.miniProgram.navigateBack({})
          } else {
            this.$router.replace({ path: '/gold-coin/withdraw' })
          }
        }
      })
    },
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f44d4d 0%, #fc7e7e 100%);
}
.goback {
  width: 40px;
  height: 44px;
}
.content {
  text-align: center;
  padding: 0 33px;
  img {
    width: 119px;
    height: 119px;
  }
  h3 {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 15px;
    color: #ffffff;
  }
  /deep/ .van-cell,
  .van-field {
    margin: 50px 0;
    width: 310px;
    // border-radius: 8px;
  }
  /deep/ .van-button--normal {
    width: 190px;
    height: 50px;
    background: #f44d4d;
    opacity: 1;
    border-radius: 10px;
    border: none;

    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 15px;
    color: #ffffff;
  }
}
</style>